import * as React from 'react';

function SvgDropdownIcon(props) {
  return (
    <svg
      width={28}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect opacity={0.15} width={28} height={28} rx={3} fill="#39BEF5" />
      <g clipPath="url(#dropdown-icon_svg__clip0)">
        <path
          d="M14 18.375a1.343 1.343 0 01-1.009-.455l-5.723-6.505a1.077 1.077 0 011.618-1.423l5.004 5.689a.146.146 0 00.22 0l5.004-5.689a1.077 1.077 0 111.617 1.423l-5.72 6.503a1.348 1.348 0 01-1.011.457z"
          fill="#232340"
        />
      </g>
      <defs>
        <clipPath id="dropdown-icon_svg__clip0">
          <path fill="#fff" transform="translate(7 7)" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgDropdownIcon;
